<template>
  <div class="services-area-three bg-secondary ptb-100">
    <div class="container">
      <div
        class="section-title text-center m-auto"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <span class="top-title">خدماتنا ومميزاتنا</span>
        <h2 class="text-white">اكتشف ما نقدمه لك لتجربة مشاهدة مثالية</h2>
      </div>

      <div class="row justify-content-center">
        <div
          v-for="(service, index) in services"
          :key="service.id"
          class="col-lg-4 col-sm-6"
          data-aos="fade-up"
          data-aos-duration="1000"
          :data-aos-delay="200 + index * 100"
        >
          <div class="position-relative z-1 shape-wrap">
            <div class="services-single-item-three hover-style1">
              <div class="hover-style2">
                <i :class="service.icon" class="icon"></i>
                <h3>
                  <a href="https://wa.me/447429916178" target="_blank">
                    {{ service.title }}
                  </a>
                </h3>
                <p>{{ service.description }}</p>
                <a
                  href="https://wa.me/447429916178"
                  target="_blank"
                  class="read-more style-two text-grey-teal"
                >
                  اطلب الخدمة الآن <i class="ti ti-arrow-left"></i>
                </a>
              </div>
            </div>
            <img
              src="@/assets/images/services-shape.png"
              class="services-shape d-none d-xl-block"
              alt="services-shape"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "OurServices",
  setup() {
    const services = ref([
      {
        id: 1,
        title: "بث مباشر للمباريات بجودة 4K",
        icon: "flaticon-global-network",
        description: "شاهد جميع البطولات والدوريات العالمية والكبرى بدون تقطيع وبأعلى جودة ممكنة.",
      },
      {
        id: 2,
        title: "مكتبة أفلام ومسلسلات ضخمة",
        icon: "flaticon-box",
        description: "تحديث يومي مستمر لآخر إصدارات السينما ومنصات العرض العالمية مع الترجمة الاحترافية.",
      },
      {
        id: 3,
        title: "سيرفرات فائقة السرعة والثبات",
        icon: "flaticon-global-network",
        description: "نعتمد على خوادم ذات بورتات عالية السعة لضمان استقرار البث تماماً أثناء أوقات الذروة والمباريات الهامة.",
      },
      {
        id: 4,
        title: "دعم جميع الأجهزة الذكية",
        icon: "flaticon-global-network",
        description: "تفعيل فوري وسلس على شاشات السمارت، أجهزة أندرويد، TV Box، الـ Fire Stick، والهواتف الذكية.",
      },
      {
        id: 5,
        title: "دعم فني متواصل 24/7",
        icon: "flaticon-phone-call-2",
        description: "فريق جاهز لمساعدتك عبر الواتساب في أي وقت للإجابة على استفساراتك وحل أي مشكلة تقنية فوراُ.",
      },
      {
        id: 6,
        title: "تفعيل آمن وفوري",
        icon: "flaticon-smart-home",
        description: "بمجرد إتمام الطلب، يتم توليد بيانات اشتراكك وإرسالها لك مع شرح طريقة التشغيل خلال دقائق معدودة.",
      },
    ]);

    return { services };
  },
});
</script>